// @ts-nocheck
import { ConstantAttributesService } from './constantAttributesService';
import {
  useMutationEngine,
  useNewQueryEngine,
} from '../../../../queries/useDataEngine';
import { EMPTY_OBJECT } from '../../../../const/CommonConst';

const CONSTANT_ATTRIBUTES = 'constantAttributes';

export const CONSTANT_ATTRIBUTES_QUERY_KEYS = {
  ALL: [CONSTANT_ATTRIBUTES],
  constantAttributeList: {
    ROOT: [CONSTANT_ATTRIBUTES, 'constantAttributeList'],
    key: (params = {}) => [
      CONSTANT_ATTRIBUTES,
      'constantAttributeList',
      params,
    ],
  },
  schema: {
    ROOT: [CONSTANT_ATTRIBUTES, 'schema'],
    key: (params = {}) => [CONSTANT_ATTRIBUTES, 'schema', params],
  },
  details: {
    ROOT: [CONSTANT_ATTRIBUTES, 'details'],
    key: (params = {}) => [CONSTANT_ATTRIBUTES, 'details', params],
  },
  versions: {
    ROOT: [CONSTANT_ATTRIBUTES, 'versions'],
    key: (params = {}) => [CONSTANT_ATTRIBUTES, 'versions', params],
  },
  excelStatus: {
    ROOT: [CONSTANT_ATTRIBUTES, 'excelStatus'],
    key: (params = {}) => [CONSTANT_ATTRIBUTES, 'excelStatus', params],
  },
};

export const useConstantAttributeListQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useNewQueryEngine(
    CONSTANT_ATTRIBUTES_QUERY_KEYS.constantAttributeList.key,
    ConstantAttributesService.getConstantAttributeList,
    params,
    options
  );
};

export const useConstantAttributeSchemaQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useNewQueryEngine(
    CONSTANT_ATTRIBUTES_QUERY_KEYS.schema.key,
    ConstantAttributesService.getConstantAttributeSchema,
    params,
    options
  );
};

export const useSingleConstantAttributeQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useNewQueryEngine(
    CONSTANT_ATTRIBUTES_QUERY_KEYS.details.key,
    ConstantAttributesService.getSingleConstantAttributeDetails,
    params,
    options
  );
};

export const useConstantAttributeVersionsQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useNewQueryEngine(
    CONSTANT_ATTRIBUTES_QUERY_KEYS.versions.key,
    ConstantAttributesService.getConstantAttributeVersions,
    params,
    options
  );
};

export const useExcelProcessingStatusQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useNewQueryEngine(
    CONSTANT_ATTRIBUTES_QUERY_KEYS.excelStatus.key,
    ConstantAttributesService.getExcelProcessingStatus,
    params,
    options
  );
};

export const useCreateConstantAttributeMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(ConstantAttributesService.createConstantAttribute, {
    ...options,
    invalidateQueries: [
      CONSTANT_ATTRIBUTES_QUERY_KEYS.constantAttributeList.ROOT,
    ],
  });
};

export const useUpdateConstantAttributeMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(ConstantAttributesService.updateConstantAttribute, {
    ...options,
    invalidateQueries: [
      CONSTANT_ATTRIBUTES_QUERY_KEYS.constantAttributeList.ROOT,
      CONSTANT_ATTRIBUTES_QUERY_KEYS.details.ROOT,
    ],
  });
};

export const useDeleteConstantAttributeMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(ConstantAttributesService.deleteConstantAttribute, {
    ...options,
    invalidateQueries: [
      CONSTANT_ATTRIBUTES_QUERY_KEYS.constantAttributeList.ROOT,
    ],
  });
};

export const useUpdateConstantAttributeExcelSchemaMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(
    ConstantAttributesService.updateConstantAttributeExcelSchema,
    {
      ...options,
      invalidateQueries: [CONSTANT_ATTRIBUTES_QUERY_KEYS.schema.ROOT],
    }
  );
};

export const useRollbackConstantAttributeVersionMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(
    ConstantAttributesService.rollbackConstantAttributeVersion,
    {
      ...options,
      invalidateQueries: [
        CONSTANT_ATTRIBUTES_QUERY_KEYS.versions.ROOT,
        CONSTANT_ATTRIBUTES_QUERY_KEYS.schema.ROOT,
      ],
    }
  );
};
